module.exports = __webpack_public_path__ + "img/768_banner_3.d1562ae1.jpg";